const common = {
  // Nav
  nav_materials: '资料库',
  nav_account: '我的账户',
  nav_agent_portal: '代理商门户',
  nav_sign_out: '退出登录',
  nav_account_settings: '账户设置',
  nav_download_history: '下载记录',
  nav_help: '帮助与支持',
  nav_expires_in: '到期剩余',
  nav_days: '天',
  nav_account_type: '账户类型',
  nav_region: '所在地区',
  nav_valid_until: '有效期至',
  nav_search_placeholder: '搜索资料、分类、标签...',

  // Login
  login_welcome: '欢迎回来',
  login_subtitle: '登录您的代理商账户',
  login_tab_signin: '登录',
  login_tab_apply: '申请账户',
  login_email: '邮箱地址',
  login_password: '密码',
  login_forgot: '忘记密码？',
  login_remember: '记住我 30 天',
  login_btn: '登录门户',
  login_signing_in: '登录中...',
  login_need_help: '需要帮助？',
  login_contact: '联系支持',
  login_hero_label: '代理商门户',
  login_hero_title: '获取优质医疗设备资源',
  login_hero_sub: '您专属的赛诺威盛产品资料、技术文档和销售资源通道。',
  login_secure: '安全与水印保护',
  login_secure_desc: '所有文档均受动态水印保护，下载权限按账户级别管控。',

  // Register
  reg_apply: '申请访问权限',
  reg_subtitle: '注册成为授权经销商',
  reg_email: '企业邮箱',
  reg_password: '密码',
  reg_company: '公司名称',
  reg_region: '所在地区',
  reg_region_placeholder: '请选择地区',
  reg_btn: '提交申请',
  reg_submitting: '提交中...',
  reg_pending_title: '申请已提交',
  reg_pending_badge: '待审核',
  reg_pending_desc: '您的申请正在审核中，审核通过后您将收到邮件通知，通常需要 1-2 个工作日。',
  reg_back_signin: '返回登录',

  // Library
  lib_showing: '共显示',
  lib_materials: '份资料',
  lib_no_results: '未找到相关资料',
  lib_no_results_sub: '请尝试调整搜索词或筛选条件',
  lib_clear_filters: '清除筛选',
  lib_preview: '预览',
  lib_download: '下载',
  lib_no_permission: '无下载权限',
  lib_popular: '热门',
  lib_categories: '分类',
  lib_sort_by: '排序方式',
  lib_sort_latest: '最新上传',
  lib_sort_popular: '最受欢迎',
  lib_sort_az: 'A → Z',
  lib_file_type: '文件类型',
  lib_all_types: '全部类型',
  lib_pdf: 'PDF 文档',
  lib_ppt: '演示文稿',
  lib_all_materials: '全部资料',
  lib_collapse_models: '收起型号',
  lib_expand_models: '展开型号',

  // Primary categories
  primary_products: '产品线',
  primary_training: '培训与学习',
  primary_software: '软件与系统',

  // Preview Modal
  preview_page: '第',
  preview_of: '/',
  preview_preview_only: '仅供预览 — 下载需要相应权限',
  lib_view_only: '仅浏览',
  lib_watermark_protected: '水印保护',

  // Admin Nav
  admin_nav_dashboard: '仪表盘',
  admin_nav_agents: '代理商管理',
  admin_nav_materials: '资料管理',
  admin_nav_permissions: '权限管理',
  admin_nav_analytics: '数据分析',
  admin_nav_watermark: '水印设置',
  admin_back_portal: '返回门户',

  // Account
  acc_active: '账户正常',
  acc_expires_in: '账户将在',
  acc_expires_days: '天后到期',
  acc_expires_contact: '请联系您的赛诺威盛区域经理进行续期。',
  acc_renew: '立即续期',
  acc_overview: '概览',
  acc_history: '下载记录',
  acc_permissions: '访问权限',
  acc_granted: '已授权',
  acc_restricted: '受限',
  acc_quick_actions: '快捷操作',
  acc_browse: '浏览资料库',
  acc_contact: '联系支持',
  acc_change_pw: '修改密码',
  acc_upgrade_title: '需要更多权限？',
  acc_upgrade_sub: '升级您的权限',
  acc_upgrade_desc: '请联系您的赛诺威盛区域经理，解锁更多下载权限。',
  acc_upgrade_btn: '申请升级',
  acc_recent_dl: '最近下载',
  acc_redownload: '重新下载',
  acc_account_type: '账户类型',
  acc_region: '所在地区',
  acc_member_since: '注册时间',
  acc_valid_until: '有效期至',
};

export default common;
